import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define a service using a base URL and expected endpoints
export const emepayrollApi = createApi({
  reducerPath: 'emepayroll',
  baseQuery: btBaseQuery,
  tagTypes: ['Payroll'],

  endpoints: (builder) => ({
    getPayrolls: builder.query<em_epayroll[], string>({
      query: (cid) => `empayroll/${cid}`,
      providesTags: ['Payroll']
    }),
    getPayroll: builder.query<em_epayroll, string>({
      query: (id) => `empayroll/byid/${id}`
    }),
    getPayrollsByDate: builder.query<
      (em_epayroll & em_memployee & em_mdepartment)[],
      any
    >({
      query: ({ cid, yr, mon }) => `empayroll/bydate/${cid}/${yr}/${mon}`
    }),
    insertPayroll: builder.mutation({
      query: (empayroll) => ({
        url: `empayroll/`,
        method: 'POST',
        body: empayroll
      }),
      invalidatesTags: ['Payroll']
    }),
    updatePayroll: builder.mutation({
      query: (empayroll) => ({
        url: `empayroll/`,
        method: 'PUT',
        body: empayroll
      }),
      invalidatesTags: ['Payroll']
    }),
    deletePayroll: builder.mutation({
      query: (empayroll) => ({
        url: `empayroll/${empayroll.company}/${empayroll.year}/${empayroll.month}`,
        method: 'DELETE',
        body: empayroll
      }),
      invalidatesTags: ['Payroll']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPayrollsQuery,
  useGetPayrollQuery,
  useGetPayrollsByDateQuery,
  useLazyGetPayrollsByDateQuery,
  useInsertPayrollMutation,
  useUpdatePayrollMutation,
  useDeletePayrollMutation
} = emepayrollApi;
